export const generateHTML = (data) => {
  const totalInvoiceValue = data?.InvoiceDetails?.reduce(
    (sum, item) => sum + Number(item.InvoiceValue || 0),
    0
  );

  const invoicesHTML = data.InvoiceDetails.map(
    (item, i) => `
    <tr>
      <td style="border:1px solid #000; padding:6px;">${i + 1}</td>
      <td style="border:1px solid #000; padding:6px;">${item.InvoiceNo}</td>
       <td style="border:1px solid #000; padding:6px;">${item.InvoiceDate}</td>
      <td style="border:1px solid #000; padding:6px;">${item.InvoiceQty}</td>
      <td style="border:1px solid #000; padding:6px; text-align:right;">${
        item.InvoiceValue
      }</td>
    </tr>
  `
  ).join("");

  return `
  <html>
  <head>
    <style>
      body { font-family: Arial; padding: 10px; }
      h1, h2, h3 { margin: 5px 0; }
      table { width: 100%; border-collapse: collapse; margin-top: 10px; }
      td, th { border: 1px solid #000; padding: 6px; font-size: 12px; }
       .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 2px solid #000;
      padding-bottom: 5px;
    }

    .logo {
      height: 100px;
      width: auto;
      margin-top: 15px;
      margin-left: 10px;
    }

    .section-title {
      text-align: center;
      font-weight: bold;
      margin: 10px 0;
      font-size: 16px;
    }
      table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
      font-size: 12px;
    }

    td, th {
      border: 1px solid #333;
      padding: 6px;
    }

    .no-border td, .no-border th {
      border: none;
    }
      .header-table {
  width: 100%;
  border-bottom: 2px solid #000;
  padding-bottom: 5px;
}

.header-table td {
  vertical-align: middle;
}
  .address {
  text-align: right;
}
    .bold { font-weight: bold; }
    .right { text-align: right; }
    .center { text-align: center; }
    </style>
  </head>
  <body>
 <table class="header-table">
  <tr>
    <!-- Logo on LEFT -->
    <td style="width: 30%;">
      <img
        src="https://cdn.dribbble.com/userupload/27139137/file/original-0abbbcef53d5e3f30b9b852328ac5bb2.jpg"
        class="logo"
      />
    </td>

    <!-- Address on RIGHT -->
    <td class="address" style="width: 70%;">
      <h3>Hypermax City Private Limited</h3>
      <p>
        Unit No 502, Block 4A, DLF Corporate Park<br />
        MG Road, Gurugram
      </p>
    </td>
  </tr>
</table>

  <h2 class="center">Inward Receipt Note</h2>
  <hr/>
<p><b>IRN No:</b> ${data.IRNNo}</p>
  <p><b>IRN Date:</b> ${data.IRNDate}</p>
  <p><b>Created By:</b> ${data.IRNBy}</p>
  <h3>Purchase Order Details</h3>
  <table>
    <tr><td>Store Code</td><td>${data.StoreCode}</td></tr>
    <tr><td>Store Name</td><td>${data.StoreName}</td></tr>
    <tr><td>PO No</td><td>${data.PONo}</td></tr>
    <tr><td>PO Date</td><td>${data.PODate}</td></tr>
    <tr><td>Total PO Qty</td><td>${data.PoQty}</td></tr>
    <tr><td>Total PO Value</td><td>${data.POValue}</td></tr>
  </table>

  <h3>Supplier Details</h3>
  <table>
    <tr><td>Supplier Code</td><td>${data.SupplierCode}</td></tr>
    <tr><td>Supplier Name</td><td>${data.SupplierName}</td></tr>
  </table>

  <h3>Vehicle Details</h3>
  <table>
    <tr><td>Vehicle No</td><td>${data.VehicleNo}</td></tr>
    <tr><td>Delivery Person</td><td>${data.DeliveryPersonName}</td></tr>
    <tr><td>Courier Agency</td><td>${data.CourierAgenecyName || "-"}</td></tr>
    <tr><td>No Of Boxes</td><td>${data.NoOfBoxes}</td></tr>
    <tr><td>Weight</td><td>${data.BoxWeight}</td></tr>
  </table>

  <h3>Invoice Details</h3>
  <table>
    <tr>
      <th>S.No</th>
      <th>Invoice No</th>
      <th>Invoice Date</th>
      <th>Qty</th>
      <th>Value</th>
    </tr>
    ${invoicesHTML}
    <tr>
      <td colspan="4" style="text-align:right; font-weight:bold;">Total</td>
      <td style="text-align:right; font-weight:bold;">${totalInvoiceValue}</td>
    </tr>
  </table>

  
  </body>
  </html>
  `;
};
